<!--This component (step 4) to choose items-->
<template>
  <v-card-text>
    <!--Start menu-->
    <div class="mb-16 headline font-weight-bold headline1--text">
      <span
        v-if="itemsStepTitle && itemsStepTitle[language]"
        v-html="itemsStepTitle[language]"
      ></span>

      <span v-else>
        {{ $t("generic.lang_menu_title") }}
      </span>
    </div>

    <div v-if="Array.isArray(menuTypes) && menuTypes.length">
      <v-tabs
        v-model="tab"
        background-color="secondary"
        active-class="primary white--text"
        hide-slider
        grow
        show-arrows
        center-active
        centered
      >
        <v-tab
          v-for="menuType in menuTypes"
          :key="menuType.uuid"
          :href="`#${menuType.uuid}`"
        >
          {{ menuType.name }}
        </v-tab>
      </v-tabs>

      <!-- loader -->
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        size="120"
      />
      <!-- end loader -->

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="menuType in menuTypes"
          :key="menuType.uuid"
          :value="`${menuType.uuid}`"
        >
          <!--start item card component-->
          <item-card-component />
          <!--end item card component-->
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-sheet
      v-else
      elevation="0"
      outlined
      height="200"
      class="d-flex justify-center align-center"
    >
      <p>
        {{ $t("generic.lang_no_items_available") }}
      </p>
    </v-sheet>

    <!--End menu-->
  </v-card-text>
</template>

<script>
import ItemCardComponent from "@/components/itemCard/ItemCardComponent.vue";

/*import plugins*/
import { createNamespacedHelpers } from "vuex";

export default {
  name: "Step4Component",

  components: {
    ItemCardComponent,
  },

  data() {
    return {
      tab: null,
    };
  },

  watch: {
    tab(val) {
      this.$store.dispatch("items/fetchItems", val);
    },
  },

  computed: {
    //map loader getters
    ...createNamespacedHelpers("loader").mapGetters(["loading"]),
    ...createNamespacedHelpers("items").mapGetters(["menuTypes"]),
    ...createNamespacedHelpers("config").mapGetters(["itemsStepTitle"]),

    language() {
      return this.$i18n.locale;
    },
  },
};
</script>
